/* eslint-disable react/prop-types */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './style';

const ConfirmationModal = ({ open, handleAction, handleClose, modalLabel, confirmAction }) => {
  const classes = styles();

  return (
      <Dialog
        open={open}
        onClose={() => {
          handleClose(false);
        }}
        fullWidth={true}
        className={classes.dialogModal}
      >
        <Box className={classes.dialogTitle}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>Attention!</Grid>
              <Grid item>
                <IconButton
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <CancelPresentationRounded fontSize='large' />
                </IconButton>
              </Grid>
            </Grid>
          </Typography>
        </Box>
        <Divider />
        <DialogContent style={{ marginTop: '2px' }}>
          <DialogContentText align='center' style={{ marginLeft: '-0.7rem' }} color={'black'} fontSize={'18px'} fontWeight='bold' id="alert-dialog-description">
            {modalLabel}
          </DialogContentText>
        </DialogContent>
        <Grid container item justifyContent='center' margin='7% 0'>
          <DialogActions>
            <Button
              style={{
                backgroundColor: '#444',
                width: '100px',
                cursor: confirmAction ? 'wait' : '',
                opacity: confirmAction ? 0.6 : 1,
              }}
              onClick={!confirmAction ? handleAction : undefined}
            >
              Ok
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.any,
  handleAction: PropTypes.any,
  handleClose: PropTypes.any,
  deleteRow: PropTypes.any,
  modalLabel: PropTypes.any,
  confirmAction: PropTypes.any
};

export default ConfirmationModal;
